import { useEffect, useState } from 'react';
import { useCreateStripeSetupIntentMutation } from 'lib/home/generated/queries';

export const useStripeSetupIntent = () => {
  // Using component state, since we don't want to keep the `clientSecret` around for long.
  const [clientSecret, setClientSecret] = useState<string | null>(null);

  const { mutate } = useCreateStripeSetupIntentMutation({
    onSuccess: data => setClientSecret(data.createStripeSetupIntent.client_secret)
  });

  useEffect(() => {
    mutate({});
  }, [mutate]);

  return { clientSecret };
};
